"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var utils_1 = require("../utils");
var ProductCard = function (_a) {
    var product = _a.product;
    var stars = Array.from(Array(5 + 1).keys()).slice(1);
    var _b = react_1.useState(product.wishlist), wishlist = _b[0], setWishlist = _b[1];
    var handleWishlist = function () {
        if (wishlist === 0) {
            utils_1.wishListAdd(product.id)
                .then(function (res) {
                if (res.status === 200) {
                    setWishlist(1);
                }
            })
                .catch(function (res) {
                var _a;
                if (((_a = res.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    window.location.href = process.env.MIX_LADARA_BASE_URL + "login";
                }
            });
        }
        else {
            utils_1.wishListRemove(product.id).then(function (res) {
                if (res.status === 200) {
                    setWishlist(0);
                }
            });
        }
    };
    var isDiscount = product.discount.int > 0;
    return (react_1.default.createElement("div", { className: "col-xs-6 col-md-4 col_bx_productList" },
        react_1.default.createElement("div", { className: "bx_productList" },
            react_1.default.createElement("div", { className: "mg_heart " + (wishlist === 1 ? "act" : ""), title: "Tambah ke wishlist", onClick: handleWishlist },
                react_1.default.createElement("span", { className: "glyphicon glyphicon-heart" })),
            react_1.default.createElement("a", { href: process.env.MIX_LADARA_BASE_URL + "product/" + product.permalink + "-" + product.id, title: "Lihat " + product.name },
                react_1.default.createElement("div", { className: "mg_productList" },
                    product.product_card_badges.product_image_badge &&
                        !product.product_card_badges.use_frame && (react_1.default.createElement("img", { className: "mg_productList__umkm-badge", src: product.product_card_badges
                            .product_image_badge, alt: "" })),
                    (product.product_card_badges.promo_badge) ? (react_1.default.createElement("img", { className: "mg_productList__promo-badge", src: product.product_card_badges
                            .promo_badge, alt: "" })) : null,
                    product.product_card_badges.frame &&
                        product.product_card_badges.use_frame && (react_1.default.createElement("img", { className: "mg_productList__product-frame", src: product.product_card_badges.frame, alt: "" })),
                    product.preorder_duration > 0 && (react_1.default.createElement("div", { className: "preorder-badge" }, "Preorder")),
                    react_1.default.createElement("img", { className: "lazy", src: product.images, alt: product.name })),
                react_1.default.createElement("div", { className: "bx_in_productList" },
                    react_1.default.createElement("h4", { className: "ht_productList" }, product.name.length >= 40
                        ? product.name.substring(0, 40) + "..."
                        : product.name),
                    react_1.default.createElement("div", { className: "tx_price" },
                        "Rp",
                        " ",
                        (isDiscount
                            ? product.sale_price
                            : product.price).toLocaleString("ID-id")),
                    isDiscount && (react_1.default.createElement("div", { className: "tx_price_sale", style: { textDecoration: "none" } },
                        react_1.default.createElement("span", { style: { textDecoration: "line-through" } },
                            "Rp ",
                            product.price.toLocaleString("ID-id")),
                        " ",
                        react_1.default.createElement("span", { className: "discount" }, product.discount.text))),
                    react_1.default.createElement("div", { className: "bx_rate_product" }),
                    product.rating > 0 && (react_1.default.createElement("div", { className: "rating-star-container" },
                        stars.map(function (star, i) {
                            return (react_1.default.createElement("div", { key: i, className: "rating-star " + (i + 1 <= product.rating &&
                                    "point") }));
                        }),
                        react_1.default.createElement("span", { className: "total-sale" },
                            "(",
                            product.total_ulasan,
                            ")"))),
                    react_1.default.createElement("div", { className: "product-card-footer" },
                        product.product_card_badges.province_badge ? (react_1.default.createElement("img", { className: "product-card-footer__badge", src: product.product_card_badges
                                .province_badge })) : (react_1.default.createElement("i", { className: "glyphicon glyphicon-map-marker product-card-footer__pin-icon" })),
                        product.province_str),
                    product.total_sales > 0 && (react_1.default.createElement("div", { className: "product-card-footer product-card-footer--smallfont" },
                        "Terjual ",
                        product.total_sales)))))));
};
exports.default = ProductCard;
